var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningEditTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4629 17.7625L17.0629 4.2875C16.3629 3.2375 15.2254 2.625 14.0004 2.625C12.7754 2.625 11.6379 3.2375 10.9379 4.2875L2.53789 17.7625C1.57539 19.3375 1.48789 21.175 2.36289 22.75C3.23789 24.325 4.90039 25.2875 6.73789 25.2875H21.2629C23.1004 25.2875 24.7629 24.325 25.6379 22.75C26.5129 21.175 26.4254 19.3375 25.4629 17.7625ZM12.1629 9.5375C13.0379 8.4875 14.8754 8.4875 15.7504 9.5375C16.1879 10.0625 16.4504 10.7625 16.2754 11.4625L15.6629 15.8375C15.5754 16.275 15.2254 16.625 14.7879 16.625H13.0379C12.6004 16.625 12.2504 16.275 12.1629 15.8375L11.5504 11.4625C11.5504 10.7625 11.7254 10.0625 12.1629 9.5375ZM14.4379 21.875H13.5629C12.3379 21.875 11.3754 20.9125 11.3754 19.6875C11.3754 18.4625 12.3379 17.5 13.5629 17.5H14.4379C15.6629 17.5 16.6254 18.4625 16.6254 19.6875C16.6254 20.9125 15.6629 21.875 14.4379 21.875Z",
    fill: "#F63C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningEditTime);
export default __webpack_public_path__ + "static/media/warningEditTime.7599c9642aad47b845c4979bbf53462c.svg";
export { ForwardRef as ReactComponent };